import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.drugClasses;
export const drugClassesSelector = (state: RootState) => getState(state).data;
export const drugClassesIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const drugClassesIsReadySelector = (state: RootState) => getState(state).isReady;
export const drugClassesErrorSelector = (state: RootState) => getState(state).error;
